/**
 * 컴퍼넌트 i18n
 * 문자열은 항상 $$로 시작한다. $$로 시작하는 경우 코어의 I18n 서비스로 자동 상향된다.
 * 따라서, 코어 I18n 관리툴에서 다른 언어로 상응하는 값을 입력할 수 있다.
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @json
 */
export const I18n = {
    componentElement: {
        checkbox: {
            label: "Checkbox",
            description: "Checkbox Component"
        },
        checkboxMultiple: {
            label: "Checkbox (Multiple)",
            description: "Multiple Checkbox Component"
        },
        checkboxSingle: {
            label: "Checkbox (Single)",
            description: "Single Checkbox Component"
        },
        checkboxTristate: {
            label: "Checkbox (Tristate)",
            description: "Tristate Checkbox Component"
        },
        chips: {
            label: "Chips",
            description: "Chips Component"
        },
        dropdown: {
            label: "Dropdown",
            description: "Dropdown Component"
        },
        dropdownMultiple: {
            label: "Dropdown (Multiple)",
            description: "Multiple Dropdown Component"
        },
        inputmask: {
            label: "Input Mask",
            description: "Input Mask Component"
        },
        inputmaskMultiple: {
            label: "Input Mask (Multiple)",
            description: "Multiple Input Mask Component"
        },
        inputsecurity: {
            label: "Input Security",
            description: "Input Security Component"
        },
        inputswitch: {
            label: "Input Switch",
            description: "Input Switch Component"
        },
        inputtext: {
            label: "Input Text",
            description: "Input Text Component"
        },
        inputtextnumeric: {
            label: "Input Number",
            description: "Input Number Component"
        },
        inputtextarea: {
            label: "Input Textarea",
            description: "Input Textarea Component"
        },
        autocomplete: {
            label: "Auto Complete",
            description: "Auto Complete Component"
        },
        autocompleteMultiple: {
            label: "Auto Complete (Multiple)",
            description: "Multiple Auto Complete Component"
        },
        password: {
            label: "Password",
            description: "Password Component"
        },
        radiobutton: {
            label: "Radio Button",
            description: "Radio Button Component"
        },
        spinner: {
            label: "Spinner",
            description: "Spinner Component"
        },
        slider: {
            label: "Slider",
            description: "Slider Component"
        },
        rangedslider: {
            label: "Ranged Slider",
            description: "Ranged Slider Component"
        },
        togglebutton: {
            label: "Toggle Button",
            description: "Toggle Button Component"
        },
        editor: {
            label: "Editor",
            description: "Editor Component"
        },
        label: {
            label: "Label",
            description: "Label Component"
        },
        link: {
            label: "Link",
            description: "Link Component"
        },
        image: {
            label: "Image",
            description: "Image Component"
        },
        signature: {
            label: "Signature",
            description: "Signature Component"
        },
        eSignature: {
            label: "Electronic Signature",
            description: "Electronic Signature Component"
        },
        colorPicker: {
            label: "Color Picker",
            description: "Color Picker Component"
        },
        currency: {
            label: "Currency",
            description: "Currency Component"
        },
        button: {
            label: "Button",
            description: "Button Component"
        },
        splitButton: {
            label: "Split Button",
            description: "Split Button Component"
        },
        panelMenu: {
            label: "Panel Menu",
            description: "Panel Menu Component"
        },
        menuBar: {
            label: "Menu Bar",
            description: "Menu Bar Component"
        },
        accordionMenu: {
            label: "Accordion Menu",
            description: "Accordion Menu Component"
        },
        tieredMenu: {
            label: "Tiered Menu",
            description: "Tiered Menu Component"
        },
        steps: {
            label: "Steps",
            description: "Steps Component"
        },
        menu: {
            label: "Menu",
            description: "Menu Component"
        },
        slideMenu: {
            label: "Slide Menu",
            description: "Slide Menu Component"
        },
        user: {
            label: "User",
            description: "User Component"
        },
    },
    calendar: {
        datePicker: {
            label: "Date Picker",
            description: "Date Picker Component"
        },
        multipleDatePicker: {
            label: "Date Picker (Multiple)",
            description: "Multiple Date Picker"
        },
        monthPicker: {
            label: "Month Picker",
            description: "Month Picker Component"
        },
        timePicker: {
            label: "Time Picker",
            description: "Time Picker Component"
        },
        dateTimePicker: {
            label: "Date Time Picker",
            description: "Date Time Picker Component"
        },
        inlineDatePicker: {
            label: "Inline Date Picker",
            description: "Inline Date Picker Component"
        },
        inlineTimePicker: {
            label: "Inline Time Picker",
            description: "Inline Time Picker Component"
        }
    },
    handler: {
        modalPanel: {
            label: "Modal Panel",
            description: "A modal panel is a dialog page/box that is displayed on top of the current page"
        },
        embedFormPanel: {
            label: "Embed Form Panel",
            description: "Embed Form Panel"
        },
        embedPagePanel: {
            label: "Embed Block Panel",
            description: "Embed Block Panel"
        }
    },
    layout: {
        autoFillPanel: {
            label: "Auto Fill Panel",
            description: "Panel that occupy every space except space of docking panel",
            bgColor: "Background Color"
        },
        dockFloatPanel: {
            label: "Dock or Float Panel",
            description: "Panel that stick or float to end of the display",
            bgColor: "Background Color",
            priority: "Priority",
            position: "Position",
            resize: "Resize"
        },
        tabViewPanel: {
            label: "TabView Panel",
            description: "Panel that each tab has view panel"
        },
        gridLayout: {
            label: "Grid Layout",
            description: "Responsive grid based on Bootstrap's grid system"
        },
        flexLayout: {
            label: "Flex Layout",
            description: "A layout component that defines a CSS flexible box model optimized for user interface design."
        },
        fieldset: {
            label: "Fieldset",
            description: "A grouping component that may be expanded or collapsed"
        },
        panel: {
            label: "Panel",
            description: "A grouping component that may be expanded or collapsed"
        },
        scrollPanel: {
            label: "Scroll Panel",
            description: "Scroll Panel is a cross browser, lightweight and skinnable alternative to native browser scrollbar."
        },
        accordion: {
            label: "Accordion Panel",
            description: "A layout component with one or more tabs; each tab contains data entities or other components"
        },
        card: {
            label: "Card",
            description: "Card presents a collection of contents in card."
        },
        iframe: {
            label: "Iframe Panel",
            description : "Panel component that contain an iframe inside."
        },
        window: {
            label: "window Panel",
            description : "Window component that can include another panel or component inside."
        }
    },
    data: {
        pickListFormData: {
            label: "Pick List Form Data",
            description: "Pick List Form Data Component Element"
        },
        pickListLookupData: {
            label: "Pick List Lookup Data",
            description: "Pick List Lookup Data Component Element"
        },
        treeTable: {
            label: "Tree Table",
            description: "Tree Table Component"
        },
        tree: {
            label: "Tree",
            description: "Tree Component"
        },
        singleSelectTree: {
            label: "Single Select Tree",
            description: "Single Select Tree Component"
        },
        multipleSelectTree: {
            label: "Multiple Select Tree",
            description: "Multiple Select Tree Component"
        },
        dataTable: {
            label: "Data Table",
            description: "Data Table Component"
        }
    },
    file: {
        fileUpload: {
            label: "File Upload",
            description: "File Upload Component Element"
        }
    }
};
